mutation UpdateGeometryType(
    $geometryType: GeometryTypeRevisionInput!
    $id: ID!
) {
    updateGeometryType(
        geometryType: $geometryType
        id: $id
    ) {
        errors {
            message
        }
        geometryTypeRevision {
            id
        }
    }
}
